<input
  #input
  type="text"
  [ngbTypeahead]="searchBinding"
  [placeholder]="placeHolder"
  [resultFormatter]="formatResults"
  (selectItem)="onSelectItem($event)" />
